const sliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".js-media-list") &&
    document.querySelectorAll(".js-media-list").length > 0
  ) {
    document.querySelectorAll(".js-media-list").forEach((elem, index) => {
      const direction = elem.dataset.direction;
      const galleryType = elem.dataset.galleryType;

      let mousewheel = true;
      if (direction == "horizontal") {
        mousewheel = false;
      }

      const directionDesc = elem.dataset.direction_desc;
      const sliderType = elem.dataset.sliderType;

      let mousewheel_desc = true;
      if (directionDesc == "horizontal") {
        mousewheel_desc = false;
      }

      let defaultConfigs = {
        slidesPerView: 1,
        spaceBetween: 0,
      }
      if (galleryType == 'full_horizontal_slider') {
        defaultConfigs = {
          slidesPerView: window.innerWidth < 750 ? 1 : 1.1,
          spaceBetween: 10,
        }
      }

      let slider = new Swiper(elem, {
        ...defaultConfigs,
        autoHeight: true,
        mousewheel: {
          enabled: mousewheel,
        },
        direction: direction,
        speed: 500,
        //loop: false,
        //observeParents: true,
        //freeMode: {
        //	enabled: !!elem
        //		.closest(".product__outer")
        //		.classList.contains("product__outer--multiple-top"),
        //	sticky: true,
        //},
        breakpoints: {
          750: {
            mousewheel: {
              enabled: mousewheel_desc,
            },
            direction: directionDesc,
          },
        },
        navigation: {
          nextEl: ".product .product__slider-nav .swiper-button-next",
          prevEl: ".product .product__slider-nav .swiper-button-prev",
        },
        pagination: {
          el: ".product .product__pagination",
          type: "bullets",
          clickable: true,
        },
        thumbs: {
          swiper: elem.nextElementSibling.querySelector(".js-media-sublist")
            ? elem.nextElementSibling.querySelector(".js-media-sublist").swiper
            : "",
        },
        on: {
          //afterInit: function (swiper) {
          //	if (document.querySelector(".product__outer--multiple-top")) {
          //		document
          //			.querySelectorAll(".product__media-toggle")
          //			.forEach((elem, index) => {
          //				elem.addEventListener("click", (e) => {
          //					var target = e.currentTarget;

          //					if (
          //						document.querySelector(".js-popup-slider") &&
          //						document.querySelector(".js-popup-slider").swiper
          //					) {
          //						document
          //							.querySelector(".js-popup-slider")
          //							.swiper.slideTo(index);
          //					}
          //				});
          //			});
          //	}
          //},
          slideChangeTransitionStart: function () {
            if (document.querySelector(".js-media-sublist")) {
              document
                .querySelector(".js-media-sublist")
                .swiper.slideTo(
                  document.querySelector(".js-media-list").swiper.activeIndex
                );
            }
          },
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;

            //if (
            //	document.querySelector(".js-popup-slider") &&
            //	document.querySelector(".js-popup-slider").swiper &&
            //	!document.querySelector(".product__outer--multiple-top")
            //) {
            //	document
            //		.querySelector(".js-popup-slider")
            //		.swiper.slideTo(this.activeIndex);
            //}
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              this.slides[this.activeIndex]
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector("model-viewer")
                  .classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });

      //if (sliderType === "main-product") {
      //	optimizingVisibleSliderElements(
      //		elem,
      //		".product__media-item.swiper-slide"
      //	);
      //}

      if (isUpdate) {
        setTimeout(function () {
          slider.update();
        }, 400);
      }
    });
  }
};

const sliderDestroy = (section) => {
  if (
    document.querySelectorAll('.js-media-list') &&
    document.querySelectorAll('.js-media-list').length > 0
  ) {
    document.querySelectorAll('.js-media-list').forEach((elem) => {
      const swiperWrapper = elem.querySelector('.js-media-wrapper')
      const swiperSlides = elem.querySelectorAll('.js-media-item')

      if (!swiperWrapper || !swiperSlides) return
      if (!elem?.swiper) return

      elem.swiper.destroy(true, true)

      swiperWrapper.classList.remove('swiper')
      swiperWrapper.classList.remove('swiper-wrapper')

      swiperSlides.forEach((slide) => {
        slide.removeAttribute('style')
        slide.classList.remove('swiper-slide')
      })
    })
  }
}

//function forceUpdateSwiperHeight(slider) {
//	const activeSlide = slider.slides[slider.activeIndex];
//	if (activeSlide) {
//		const height = activeSlide.querySelector(".product__media").offsetHeight;

//		slider.el.style.height = height + "px";
//		slider.wrapperEl.style.height = height + "px";
//	}
//}

function forceUpdateSwiperHeight() {
  const sliders = document.querySelectorAll(".js-media-list");
  sliders.forEach((sliderEl) => {
    const swiperInstance = sliderEl.swiper;

    if (swiperInstance && swiperInstance.slides) {
      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      if (activeSlide) {
        const media = activeSlide.querySelector(".product__media");

        if (media) {
          const height = media.offsetHeight;
          swiperInstance.wrapperEl.style.height = height + "px";
        }
      }
    }
  });
}

window.addEventListener("resize", () => {
  setTimeout(function () {
    forceUpdateSwiperHeight();
  }, 100);
});

const subSliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".js-media-sublist") &&
    document.querySelectorAll(".js-media-sublist").length > 0
  ) {
    document.querySelectorAll(".js-media-sublist").forEach((elem, index) => {
      if (index >= 1) return;

      const direction = elem.dataset.direction;
      const sliderType = elem.dataset.sliderType;

      let subSlider = new Swiper(elem, {
        slidesPerView: "auto",
        direction: direction,
        freeMode: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        autoHeight: true,
        //loop: false,
        //observeParents: true,
        on: {
          afterInit: function () {
            //this.params.slidesPerView = this.slides.length === 2 ? 2 : 3;
          },
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
        //transitionStart: function () {
        //	document
        //		.querySelector(".js-media-list")
        //		.swiper.slideTo(
        //			document.querySelector(".js-media-sublist").swiper.activeIndex,
        //		);
        //},
        //breakpoints: {
        //	576: {
        //		direction: "vertical",
        //		slidesPerView: "auto",
        //	},
        //},
      });

      const sliderResizeObserve = new ResizeObserver((entries) => {
        const [entry] = entries;
        setTimeout(() => {
          const sliders = document.querySelectorAll(".js-media-list");
          const thumbs = document.querySelectorAll(".product__media-sublist");
          if (sliders.length > 0 && thumbs.length > 0) {
            if (index >= 0 && index < sliders.length) {
              const sliderHeight =
                sliders[index].getBoundingClientRect().height;
              thumbs[index].style.height = `${sliderHeight - 1}px`;
            }
          }
        }, 400);
      });

      if (document.querySelector(".product-section"))
        sliderResizeObserve.observe(document.querySelector(".product-section"));

      //if (sliderType === "sub-product") {
      //	optimizingVisibleSliderElements(
      //		elem,
      //		".product__media-subitem.swiper-slide"
      //	);
      //}

      if (isUpdate) {
        setTimeout(function () {
          subSlider.update();
        }, 800);
      }
    });
  }
};

const subSliderDestroy = () => {
  if (
    document.querySelectorAll('.js-media-sublist') &&
    document.querySelectorAll('.js-media-sublist').length > 0
  ) {
    document.querySelectorAll('.js-media-sublist').forEach((elem) => {
      if (!elem?.swiper) return
      elem.swiper.destroy(true, true)
    })
  }
}

function optimizingVisibleSliderElements(sliderElement, sliderItemClass) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.visibility = "visible";
        } else {
          entry.target.style.visibility = "hidden";
        }
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    }
  );

  sliderElement.querySelectorAll(sliderItemClass).forEach((slide) => {
    observer.observe(slide);
  });
}

const quickAddsliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".js-media-list") &&
    document.querySelectorAll(".js-media-list").length > 0
  ) {
    document.querySelectorAll(".js-media-list").forEach((elem, index) => {
      let slider = new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        speed: 500,
        direction: "horizontal",
        navigation: {
          nextEl: ".product .product__slider-nav .swiper-button-next",
          prevEl: ".product .product__slider-nav .swiper-button-prev",
        },
        pagination: {
          el: ".product .product__pagination",
          type: "bullets",
          clickable: true,
        },
        on: {
          // afterInit: function (swiper) {
          // 	if (document.querySelector(".product__outer--multiple-top")) {
          // 		document
          // 			.querySelectorAll(".product__media-toggle")
          // 			.forEach((elem, index) => {
          // 				elem.addEventListener("click", (e) => {
          // 					var target = e.currentTarget;

          // 					if (
          // 						document.querySelector(".js-popup-slider") &&
          // 						document.querySelector(".js-popup-slider").swiper
          // 					) {
          // 						document
          // 							.querySelector(".js-popup-slider")
          // 							.swiper.slideTo(index);
          // 					}
          // 				});
          // 			});
          // 	}
          // },
          // slideChangeTransitionStart: function () {
          // 	if (document.querySelector(".js-media-sublist")) {
          // 		document
          // 			.querySelector(".js-media-sublist")
          // 			.swiper.slideTo(
          // 				document.querySelector(".js-media-list").swiper.activeIndex,
          // 			);
          // 	}
          // },
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;

            // if (
            // 	document.querySelector(".js-popup-slider") &&
            // 	document.querySelector(".js-popup-slider").swiper &&
            // 	!document.querySelector(".product__outer--multiple-top")
            // ) {
            // 	document
            // 		.querySelector(".js-popup-slider")
            // 		.swiper.slideTo(this.activeIndex);
            // }
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              this.slides[this.activeIndex]
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector("model-viewer")
                  .classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          slider.update();
        }, 800);
      }
    });
  }
};

const popupSliderInit = (isUpdate) => {
  if (document.querySelector(".js-popup-slider")) {
    //let popupSlider = new Swiper(document.querySelector(".js-popup-slider"), {
    //	slidesPerView: 1,
    //	//navigation: {
    //	//	nextEl: ".product-media-modal .product__slider-nav .swiper-button-next",
    //	//	prevEl: ".product-media-modal .product__slider-nav .swiper-button-prev",
    //	//},
    //	//pagination: {
    //	//	el: ".product-media-modal .product__pagination",
    //	//	type: "bullets",
    //	//	clickable: true,
    //	//},
    //	on: {
    //		afterInit: function () {
    //			if (
    //				document.querySelector(
    //					".product__outer--static-multicolumns-aside"
    //				) ||
    //				document.querySelector(".product__outer--static-column-aside")
    //			) {
    //				document
    //					.querySelectorAll(".product__media-list .product__media-toggle")
    //					.forEach((elem, index) => {
    //						elem.addEventListener("click", (e) => {
    //							if (
    //								document.querySelector(".js-popup-slider") &&
    //								document.querySelector(".js-popup-slider").swiper
    //							) {
    //								document
    //									.querySelector(".js-popup-slider")
    //									.swiper.slideTo(index);
    //							}
    //						});
    //					});
    //			}
    //		},
    //		slideChange: function () {
    //			window.pauseAllMedia();
    //			this.params.noSwiping = false;
    //			document
    //				.querySelector(".product-media-modal__content")
    //				.classList.remove("zoom");
    //		},
    //		touchMove: function () {
    //			document
    //				.querySelector(".product-media-modal__content")
    //				.classList.remove("zoom");
    //		},
    //		slideChangeTransitionEnd: function () {
    //			if (this.slides[this.activeIndex].querySelector("model-viewer")) {
    //				this.slides[this.activeIndex]
    //					.querySelector(".shopify-model-viewer-ui__button--poster")
    //					.removeAttribute("hidden");
    //			}
    //		},
    //		touchStart: function () {
    //			if (this.slides[this.activeIndex].querySelector("model-viewer")) {
    //				if (
    //					!this.slides[this.activeIndex]
    //						.querySelector("model-viewer")
    //						.classList.contains("shopify-model-viewer-ui__disabled")
    //				) {
    //					this.params.noSwiping = true;
    //					this.params.noSwipingClass = "swiper-slide";
    //				} else {
    //					this.params.noSwiping = false;
    //				}
    //			}
    //		},
    //	},
    //});

    if (isUpdate) {
      setTimeout(function () {
        //popupSlider.update();
      }, 800);
    }
  }
};

(function () {
  const sidebar = () => {
    let pageNav = $(".product__media-sublist__sidebar-nav");

    if (pageNav.length > 0) {
      let pageNavList = pageNav.find("a");
      let adminBarHeight = 0;

      let headings = [];
      for (let i = 0; i < pageNavList.length; i++) {
        headings[i] = $($(pageNavList[i]).attr("href"));
      }

      $(pageNavList[0]).parent().addClass("active");

      pageNavList.on("click", function (e) {
        e.preventDefault();

        const targetId = $(this).attr("href");
        const targetElement = $(targetId);

        if (targetElement.length) {
          $(".product-media-modal__dialog").animate(
            {
              scrollTop:
                targetElement.position().top +
                $(".product-media-modal__dialog").scrollTop(),
            },
            100
          );
        }
      });

      $(".product-media-modal__dialog").on("scroll", function () {
        for (let i = headings.length - 1; i >= 0; i--) {
          if ($(headings[i]).length > 0) {
            if (
              $(headings[i]).offset().top - 50 <=
              $(window).scrollTop() + adminBarHeight
            ) {
              if (!$(pageNavList[i]).parent().hasClass("active")) {
                let hasActiveItem = false;
                for (let j = i; j < headings.length; j++) {
                  if ($(pageNavList[j]).parent().hasClass("active")) {
                    hasActiveItem = true;
                  }
                }

                if (!hasActiveItem) {
                  $(pageNavList[i]).parent().addClass("active");
                }
              } else {
                for (let j = 0; j < i; j++) {
                  $(pageNavList[j]).parent().removeClass("active");
                }
              }
            } else {
              if (i !== 0) {
                $(pageNavList[i]).parent().removeClass("active");
              }
            }
          }
        }
      });
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    sidebar();
    document.addEventListener("shopify:section:load", function () {
      sidebar();
    });
  });
})();

if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1"
    );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter(
    (el) =>
      !el.closest('[aria-hidden="true"]') &&
      !el.closest('[hidden]') &&
      el.getClientRects().length > 0
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  removeTrapFocus();

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;

    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    const active = document.activeElement;

    if (!elements.length) {
      event.preventDefault();
      return;
    }

    if (event.shiftKey) {
      if (active === first || active === container || !container.contains(active)) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (active === last || !container.contains(active)) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  document.addEventListener("keydown", trapFocusHandlers.keydown);

  elementToFocus && elementToFocus.focus({ preventScroll: true });
}

function pauseAllMedia() {
  document
    .querySelectorAll(".product__media-list .js-youtube")
    .forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    });
  document
    .querySelectorAll(".product__media-list .js-vimeo")
    .forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
  document
    .querySelectorAll(".product__media-list video")
    .forEach((video) => video.pause());
  document
    .querySelectorAll(".product__media-list product-model")
    .forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

const getHeaderColorClasses = (headerElement) => {
  if (headerElement && headerElement.hasAttribute('data-header-color-scheme-light')) {
    const currentScheme = document.documentElement.getAttribute('data-scheme');
    const isDark = currentScheme === 'dark' || (currentScheme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    const schemeId = isDark
      ? headerElement.getAttribute('data-header-color-scheme-dark')
      : headerElement.getAttribute('data-header-color-scheme-light');
    return {
      solid: `color-${schemeId}`,
      transparent: 'color-background-2'
    };
  }
  return {
    solid: 'color-background-1',
    transparent: 'color-background-2'
  };
};

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus && !elementToFocus.classList.contains("card-focused"))
    elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) => {
      this.setMinimumDisable();

      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    var eventList = ["paste", "input"];

    for (event of eventList) {
      this.input.addEventListener(event, function (e) {
        const numberRegex = /^0*?[1-9]\d*$/;

        if (
          numberRegex.test(e.currentTarget.value) ||
          e.currentTarget.value === ""
        ) {
          e.currentTarget.value;
        } else {
          e.currentTarget.value = 1;
        }

        if (e.currentTarget.value === 1 || e.currentTarget.value === "") {
          this.previousElementSibling.classList.add("disabled");
        } else {
          this.previousElementSibling.classList.remove("disabled");
        }
      });
    }

    this.input.addEventListener("focusout", function (e) {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = 1;
      }
    });
  }

  setMinimumDisable() {
    if (this.input.value == 1) {
      this.querySelector('button[name="minus"]').classList.add("disabled");
    } else {
      this.querySelector('button[name="minus"]').classList.remove("disabled");
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    this.setMinimumDisable();
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(func, delay) {
  let lastTime = 0;

  return function (...args) {
    const now = Date.now();

    if (now - lastTime >= delay) {
      func.apply(this, args);
      lastTime = now;
    }
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt?.getAttribute("data-provinces");
    var provinces = JSON.parse(raw || "{}");

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".toggle-scheme-button") === button) return;
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector("button.header__localization-button") === button)
        return;
      if (
        this.querySelector("button.header__localization-lang-button") === button
      )
        return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      this.header =
        this.header || document.querySelector(".shopify-section-header");
      const main = document.querySelector("main");
      const classes = getHeaderColorClasses(this.header);
      if (
        main
          .querySelectorAll(".shopify-section")[0]
          ?.classList.contains("section--has-overlay") &&
        !this.header.classList.contains("animate")
      ) {
        this.header.classList.add(classes.solid, classes.transparent);
      }
      if (
        (this.header.classList.contains(classes.solid) || this.header.classList.contains("color-background-1")) &&
        !this.header.classList.contains("shopify-section-header-sticky")
      ) {
        this.header.classList.add(classes.transparent);
      }
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        //if (this.classList.contains("mobile-facets__wrapper"))
        //	this.closeMenuDrawer();
        //else this.closeMenuDrawer(event);
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    const classes = getHeaderColorClasses(this.header);
    if (
      (this.header.classList.contains(classes.transparent) || this.header.classList.contains("color-background-2")) &&
      !this.header.classList.contains("shopify-section-header-sticky")
    ) {
      this.header.classList.remove(classes.transparent, "color-background-2");
    }

    const main = document.querySelector("main");
    if (
      main
        .querySelectorAll(".shopify-section")[0]
        ?.classList.contains("section--has-overlay")
    ) {
      this.header.classList.remove(classes.transparent, "color-background-2");
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#SearchModal-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

    this.querySelector("#search-modal-close").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    if (document.querySelector("#search-icon-open") != null) {
      const cartLink = document.querySelector("#search-icon-open");
      if (!cartLink) return;

      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = document.getElementById("search-modal");
        const focusElement =
          this.querySelector('.header__search input:not([type="hidden"])') ||
          this.querySelector(".search__main") ||
          this.querySelector(".search__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    if (!isSafari()) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.add("overflow-clip");
    }
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    if (!isSafari()) {
      document.body.classList.remove("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-clip");
    }

    this.classList.add("hiding");

    setTimeout(() => this.classList.remove("hiding"), 700);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("search-modal", SearchModal);

class accountModal extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#accountModal-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

    this.querySelector("#account-modal-close").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#account-icon-open");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = document.getElementById("account-modal");
        const focusElement =
          this.querySelector(".account__main") ||
          this.querySelector(".account__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");

    this.classList.add("hiding");

    setTimeout(() => this.classList.remove("hiding"), 700);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("account-modal", accountModal);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );

    const modalApplyClose = this.querySelector('#ModalApplyClose');
    if (modalApplyClose) {
      modalApplyClose.addEventListener('click', this.hide.bind(this, false));
    }

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    //window.pauseAllMedia();
  }

  hide(isProductPage = false) {
    if (!this.hasAttribute("open")) return;

    let isOpen = false;

    this.removeAttribute("open");
    this.classList.add("hiding");

    if (!isProductPage) {
      removeTrapFocus(this.openedBy);
    }

    //window.pauseAllMedia();

    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });

    let CartDrawerNote = document.getElementById("CartDrawer-Note");
    let CartDrawerNoteAppla = document.getElementById("CartDrawer-Note-Applay");

    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));

      if (CartDrawerNote) {
        if (CartDrawerNote.value.trim() !== "") {
          CartDrawerNoteAppla.classList.add("show");
        } else {
          CartDrawerNoteAppla.classList.remove("show");
        }
      }
    }

    const images = document.querySelector(".product-media-modal__content");

    if (images) {
      images.classList.remove("zoom");
    }

    setTimeout(() => this.classList.remove("hiding"), 700);
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });

    if (this.closest(".product-popup") != null) {
      this.addEventListener("click", () => {
        const modal = document.querySelector(this.getAttribute("data-modal"));
        if (modal) modal.show(button);
      });
    }
  }
}

customElements.define("modal-opener", ModalOpener);

class ContentSpotGrid extends HTMLElement {
  #grid = null;
  #gridContainer = null;
  #resizeTimeout = null;
  #lastColumnCount = null;
  #gridContainerObserver = null;
  #imageObserver = null;
  #columnsChangedHandler = null;
  #resizeHandler = null;
  #sectionLoadHandler = null;
  #limitHeightDebounceTimeout = null;

  /**
   * Gets the current column count based on viewport and data-productis-in-row value
   * @returns {number} Current column count
   */
  #getCurrentColumnCount() {
    if (!this.#gridContainer) {
      this.#gridContainer = document.querySelector('[data-productis-in-row]');
    }
    if (!this.#gridContainer) return 4;

    const perRow = this.#gridContainer.getAttribute('data-productis-in-row');
    const width = window.innerWidth;

    if (perRow === 'small') {
      if (width < 576) return 1;
      if (width < 990) return 2;
      return 3;
    } else if (perRow === 'large') {
      if (width < 576) return 2;
      if (width < 990) return 3;
      return 4;
    }

    return 4;
  }

  /**
   * Calculates target DOM position for a content spot based on row number
   * @param {number} row - Content spot row number (1-based)
   * @param {number} columns - Current column count
   * @returns {number} Target DOM position (0-indexed, after which product to insert)
   */
  #calculateTargetPosition(row, columns) {
    if (row === 1) {
      return -1;
    }
    return (row - 1) * columns - 1;
  }

  /**
   * Gets the product element at a specific index (skipping content spots)
   * @param {Element} grid - Grid container
   * @param {number} productIndex - Target product index (0-based)
   * @returns {Element|null} Product element or null if not found
   */
  #getProductAtIndex(grid, productIndex) {
    let currentProductIndex = 0;
    const children = grid.children;
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (!child.hasAttribute('data-content-spot-position')) {
        if (currentProductIndex === productIndex) {
          return child;
        }
        currentProductIndex++;
      }
    }
    return null;
  }

  /**
   * Helper function to get image bottom position from a product card
   * @param {Element} product - Product element
   * @param {DOMRect} gridRect - Grid bounding rect
   * @returns {number} Bottom position relative to grid top
   */
  #getProductImageBottom(product, gridRect) {
    const image = product.querySelector('.media img, .swiper-slide .media img');
    if (image) {
      const imageRect = image.getBoundingClientRect();
      return imageRect.bottom - gridRect.top;
    }
    const productRect = product.getBoundingClientRect();
    return productRect.bottom - gridRect.top;
  }

  /**
   * Calculates the height of two product rows to match content spot 2x2 height
   * @param {Element} grid - Grid container
   * @param {Element} contentSpot - Content spot element
   * @param {number} columns - Current column count
   * @param {DOMRect} gridRect - Cached grid bounding rect (optional, will calculate if not provided)
   * @param {number} gap - Cached grid gap (optional, will calculate if not provided)
   * @returns {number|null} Height in pixels or null if cannot calculate
   */
  #calculateTwoRowsHeight(grid, contentSpot, columns, gridRect = null, gap = null) {
    if (!gridRect) {
      gridRect = grid.getBoundingClientRect();
    }
    const spotRect = contentSpot.getBoundingClientRect();
    const spotTop = spotRect.top - gridRect.top;

    const allProducts = Array.from(grid.children).filter(
      (child) => !child.hasAttribute('data-content-spot-position')
    );

    if (allProducts.length === 0) return null;

    const firstRowProducts = [];
    const secondRowProducts = [];
    const tolerance = 10;

    allProducts.forEach((product) => {
      const productRect = product.getBoundingClientRect();
      const productTop = productRect.top - gridRect.top;
      const productImageBottom = this.#getProductImageBottom(product, gridRect);

      if (Math.abs(productTop - spotTop) <= tolerance) {
        firstRowProducts.push({ element: product, top: productTop, bottom: productImageBottom });
      } else if (productTop > spotTop + tolerance) {
        if (secondRowProducts.length === 0 || Math.abs(productTop - secondRowProducts[0].top) <= tolerance) {
          secondRowProducts.push({ element: product, top: productTop, bottom: productImageBottom });
        }
      }
    });

    if (firstRowProducts.length === 0) {
      let closestProduct = null;
      let minDistance = Infinity;

      allProducts.forEach((product) => {
        const productRect = product.getBoundingClientRect();
        const productTop = productRect.top - gridRect.top;
        const distance = Math.abs(productTop - spotTop);

        if (distance < minDistance) {
          minDistance = distance;
          closestProduct = product;
        }
      });

      if (closestProduct) {
        const productRect = closestProduct.getBoundingClientRect();
        const productTop = productRect.top - gridRect.top;
        allProducts.forEach((product) => {
          const productRect = product.getBoundingClientRect();
          const productTop2 = productRect.top - gridRect.top;
          if (Math.abs(productTop2 - productTop) <= tolerance) {
            firstRowProducts.push({ element: product, top: productTop2, bottom: this.#getProductImageBottom(product, gridRect) });
          }
        });
      }
    }

    if (firstRowProducts.length === 0) {
      allProducts.slice(0, columns).forEach((product) => {
        const productRect = product.getBoundingClientRect();
        firstRowProducts.push({
          element: product,
          top: productRect.top - gridRect.top,
          bottom: this.#getProductImageBottom(product, gridRect),
        });
      });
    }

    if (secondRowProducts.length === 0 && firstRowProducts.length > 0) {
      const firstRowBottom = Math.max(...firstRowProducts.map((p) => p.bottom));
      if (gap === null || gap === undefined) {
        const gridStyles = window.getComputedStyle(grid);
        gap = parseFloat(gridStyles.gap) || parseFloat(gridStyles.rowGap) || 0;
      }

      allProducts.forEach((product) => {
        const productRect = product.getBoundingClientRect();
        const productTop = productRect.top - gridRect.top;
        if (productTop >= firstRowBottom + gap - tolerance) {
          if (secondRowProducts.length === 0 || Math.abs(productTop - secondRowProducts[0].top) <= tolerance) {
            secondRowProducts.push({
              element: product,
              top: productTop,
              bottom: this.#getProductImageBottom(product, gridRect),
            });
          }
        }
      });
    }

    if (secondRowProducts.length === 0) {
      secondRowProducts.push(...firstRowProducts);
    }

    if (firstRowProducts.length === 0) {
      return null;
    }

    const firstRowTop = Math.min(...firstRowProducts.map((p) => p.top));
    const secondRowBottom = Math.max(...secondRowProducts.map((p) => p.bottom));

    return secondRowBottom - firstRowTop;
  }

  /**
   * Limits the height of 2x2 content spots to match two product rows
   */
  #limit2x2ContentSpotHeight() {
    if (!this.#grid) return;

    const contentSpots2x2 = Array.from(this.#grid.children).filter(
      (child) =>
        child.hasAttribute('data-content-spot-position') &&
        child.getAttribute('data-content-spot-layout') === '2x2'
    );

    if (contentSpots2x2.length === 0) return;

    // Skip on mobile - use CSS fixed heights for all content spots instead
    // Clear any inline max-height when on mobile
    if (window.innerWidth < 576) {
      contentSpots2x2.forEach((spot) => {
        spot.style.maxHeight = '';
      });
      return;
    }

    const columns = this.#getCurrentColumnCount();

    // Cache grid rect and gap to avoid repeated calculations
    const gridRect = this.#grid.getBoundingClientRect();
    const gridStyles = window.getComputedStyle(this.#grid);
    const gap = parseFloat(gridStyles.gap) || parseFloat(gridStyles.rowGap) || 0;

    const updateHeights = () => {
      requestAnimationFrame(() => {
        contentSpots2x2.forEach((spot) => {
          const twoRowsHeight = this.#calculateTwoRowsHeight(this.#grid, spot, columns, gridRect, gap);
          if (twoRowsHeight && twoRowsHeight > 0) {
            spot.style.maxHeight = `${twoRowsHeight}px`;
          }
        });
      });
    };

    // Only check images from first 2 rows (we only need those for height calculation)
    const imagesNeeded = columns * 2;
    const allProductImages = this.#grid.querySelectorAll('.collection-product-card .media img, .collection-product-card .swiper-slide .media img');
    const productImages = Array.from(allProductImages).slice(0, imagesNeeded);

    let loadedCount = 0;
    const totalImages = productImages.length;

    if (totalImages === 0) {
      updateHeights();
      return;
    }

    productImages.forEach((img) => {
      if (img.complete && img.naturalHeight !== 0) {
        loadedCount++;
      }
    });

    if (loadedCount === totalImages) {
      updateHeights();
      return;
    }

    let hasUpdated = false;
    const checkAndUpdate = () => {
      if (hasUpdated) return;
      loadedCount = 0;
      productImages.forEach((img) => {
        if (img.complete && img.naturalHeight !== 0) {
          loadedCount++;
        }
      });
      if (loadedCount === totalImages) {
        hasUpdated = true;
        updateHeights();
      }
    };

    productImages.forEach((img) => {
      if (!img.complete || img.naturalHeight === 0) {
        img.addEventListener('load', checkAndUpdate, { once: true });
        img.addEventListener('error', checkAndUpdate, { once: true });
      }
    });

    // Update immediately even if not all images loaded - we'll recalculate when they load
    updateHeights();
  }

  /**
   * Repositions content spots in the DOM based on current column count
   */
  #repositionContentSpots() {
    if (!this.#grid) return;

    const columns = this.#getCurrentColumnCount();
    this.#grid.setAttribute('data-columns', columns);

    const contentSpots = Array.from(this.#grid.children).filter((child) =>
      child.hasAttribute('data-content-spot-position')
    );

    if (contentSpots.length === 0) return;

    const positionMap = new Map();
    contentSpots.forEach((spot) => {
      const row = parseInt(spot.getAttribute('data-content-spot-position'), 10);
      const targetPos = this.#calculateTargetPosition(row, columns);

      if (!positionMap.has(targetPos)) {
        positionMap.set(targetPos, []);
      }
      positionMap.get(targetPos).push(spot);
    });

    const sortedPositions = Array.from(positionMap.keys()).sort((a, b) => b - a);

    sortedPositions.forEach((targetPos) => {
      const spots = positionMap.get(targetPos);

      if (targetPos === -1) {
        const firstProduct = this.#getProductAtIndex(this.#grid, 0);
        if (firstProduct) {
          spots.forEach((spot) => {
            if (spot.nextSibling !== firstProduct && spot !== this.#grid.firstElementChild) {
              this.#grid.insertBefore(spot, firstProduct);
            }
          });
        }
      } else {
        const referenceProduct = this.#getProductAtIndex(this.#grid, targetPos);

        if (referenceProduct) {
          let insertAfter = referenceProduct;
          spots.forEach((spot) => {
            if (spot.previousSibling !== insertAfter) {
              this.#grid.insertBefore(spot, insertAfter.nextSibling);
            }
            insertAfter = spot;
          });
        } else {
          spots.forEach((spot) => {
            if (spot.parentNode === this.#grid && spot !== this.#grid.lastElementChild) {
              this.#grid.appendChild(spot);
            }
          });
        }
      }
    });

    this.#limit2x2ContentSpotHeight();
  }

  /**
   * Initializes content spot positioning
   */
  #init() {
    this.#grid = document.querySelector('#product-grid');
    if (!this.#grid) return;

    // Initial positioning
    this.#repositionContentSpots();

    // Watch for changes to data-productis-in-row attribute
    this.#gridContainer = document.querySelector('[data-productis-in-row]');
    if (this.#gridContainer) {
      this.#gridContainerObserver = new MutationObserver(() => {
        this.#repositionContentSpots();
      });
      this.#gridContainerObserver.observe(this.#gridContainer, {
        attributes: true,
        attributeFilter: ['data-productis-in-row'],
      });
    }

    // Watch for window resize to handle column count changes
    this.#lastColumnCount = this.#getCurrentColumnCount();
    this.#resizeHandler = () => {
      clearTimeout(this.#resizeTimeout);
      this.#resizeTimeout = setTimeout(() => {
        const currentColumnCount = this.#getCurrentColumnCount();
        if (currentColumnCount !== this.#lastColumnCount) {
          this.#repositionContentSpots();
          this.#lastColumnCount = currentColumnCount;
        } else {
          this.#limit2x2ContentSpotHeight();
        }
      }, 100);
    };
    window.addEventListener('resize', this.#resizeHandler);

    // Watch for image loads to recalculate heights (with debounce)
    this.#imageObserver = new MutationObserver(() => {
      clearTimeout(this.#limitHeightDebounceTimeout);
      this.#limitHeightDebounceTimeout = setTimeout(() => {
        this.#limit2x2ContentSpotHeight();
      }, 50);
    });
    this.#imageObserver.observe(this.#grid, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    // Listen for custom event from products-per-row.js
    this.#columnsChangedHandler = () => {
      setTimeout(() => {
        this.#repositionContentSpots();
      }, 50);
    };
    window.addEventListener('columnsChanged', this.#columnsChangedHandler);
  }

  connectedCallback() {
    // Execute resize as early as possible using requestAnimationFrame
    requestAnimationFrame(() => {
      const grid = document.querySelector('#product-grid');
      if (grid) {
        this.#grid = grid;
        this.#limit2x2ContentSpotHeight();
      }
    });

    this.#init();

    // Re-initialize on section load (Shopify theme editor)
    this.#sectionLoadHandler = () => {
      setTimeout(() => {
        this.#init();
      }, 100);
    };
    document.addEventListener('shopify:section:load', this.#sectionLoadHandler);
  }

  disconnectedCallback() {
    if (this.#gridContainerObserver) {
      this.#gridContainerObserver.disconnect();
      this.#gridContainerObserver = null;
    }

    if (this.#imageObserver) {
      this.#imageObserver.disconnect();
      this.#imageObserver = null;
    }

    if (this.#resizeTimeout) {
      clearTimeout(this.#resizeTimeout);
      this.#resizeTimeout = null;
    }

    if (this.#limitHeightDebounceTimeout) {
      clearTimeout(this.#limitHeightDebounceTimeout);
      this.#limitHeightDebounceTimeout = null;
    }

    if (this.#resizeHandler) {
      window.removeEventListener('resize', this.#resizeHandler);
      this.#resizeHandler = null;
    }

    if (this.#columnsChangedHandler) {
      window.removeEventListener('columnsChanged', this.#columnsChangedHandler);
      this.#columnsChangedHandler = null;
    }

    if (this.#sectionLoadHandler) {
      document.removeEventListener('shopify:section:load', this.#sectionLoadHandler);
      this.#sectionLoadHandler = null;
    }

    this.#grid = null;
    this.#gridContainer = null;
    this.#lastColumnCount = null;
  }
}

customElements.define('content-spot-grid', ContentSpotGrid);

class DeferredMedia extends HTMLElement {
  static sharedObserver = null;
  static observedElements = new WeakMap();

  constructor() {
    super();
    this.hasAutoplay = this.dataset.autoplay === 'true';
    this.video = null;

    // If autoplay is enabled, use Intersection Observer
    if (this.hasAutoplay) {
      this.#initIntersectionObserver();
    } else {
      // Otherwise, use click handler on poster button
      this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
        "click",
        this.loadContent.bind(this)
      );
    }
  }

  connectedCallback() {
    // Re-observe element if it has autoplay and was already initialized
    if (this.hasAutoplay && !DeferredMedia.observedElements.has(this)) {
      this.#initIntersectionObserver();
    }
  }

  disconnectedCallback() {
    // Remove from observed elements map
    DeferredMedia.observedElements.delete(this);

    // If no more elements observed, disconnect shared observer
    if (DeferredMedia.sharedObserver && DeferredMedia.observedElements.size === 0) {
      DeferredMedia.sharedObserver.disconnect();
      DeferredMedia.sharedObserver = null;
    }
  }

  #initIntersectionObserver() {
    // Create shared observer if it doesn't exist
    if (!DeferredMedia.sharedObserver) {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      };

      DeferredMedia.sharedObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const element = DeferredMedia.observedElements.get(entry.target);
          if (!element) return;

          if (entry.isIntersecting) {
            // Element entered viewport
            if (!element.getAttribute("loaded")) {
              element.loadContent(true);
            } else if (element.video && element.video.paused) {
              // Video is loaded but paused, resume it
              element.#playVideo();
            }
          } else {
            // Element left viewport
            if (element.video && !element.video.paused) {
              element.#pauseVideo();
            }
          }
        });
      }, options);
    }

    // Add this element to observed elements map (or re-add if reconnected)
    DeferredMedia.observedElements.set(this, this);

    // Observe this element with shared observer
    DeferredMedia.sharedObserver.observe(this);
  }

  #playVideo() {
    if (!this.video) return;

    const playPromise = this.video.play();
    if (playPromise !== undefined) {
      playPromise.catch((error) => {
        console.warn('[deferred-media] Video play prevented:', error);
      });
    }
  }

  #pauseVideo() {
    if (!this.video) return;

    this.video.pause();
  }

  loadContent(isAutoplay = false) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();

      const mediaElement = content.querySelector("video, model-viewer, iframe");
      if (mediaElement) {
        // Position media over poster (don't hide poster)
        // CSS will handle most styling, but we ensure positioning here
        if (mediaElement.tagName === 'VIDEO') {
          mediaElement.style.objectFit = 'cover';
          // Store video reference for pause/play control
          this.video = mediaElement;
        }

        this.appendChild(mediaElement);

        // If autoplay and video, play it
        if (isAutoplay && mediaElement.tagName === 'VIDEO') {
          mediaElement.muted = true;
          mediaElement.setAttribute('muted', '');
          mediaElement.setAttribute('playsinline', '');
          mediaElement.setAttribute('preload', 'auto');
          mediaElement.load();

          this.#playVideo();
        } else {
          mediaElement.focus();
        }
      }

      if (
        this.closest(".swiper")?.swiper.slides[
          this.closest(".swiper").swiper.activeIndex
        ].querySelector("model-viewer")
      ) {
        if (
          !this.closest(".swiper")
            .swiper.slides[
            this.closest(".swiper").swiper.activeIndex
          ].querySelector("model-viewer")
            .classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    // Skip if we're currently syncing to prevent duplicate API calls
    if (this._isSyncing) {
      return;
    }

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      if (!this.closest("floated-form") ||
        (this.currentVariant?.featured_media &&
          this.dataset?.variantMediaDisplay === 'show_all')
      ) {
        // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
        this.updateMedia();
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    if (this.currentVariant) {
      document.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: {
            variant: this.currentVariant,
            previousVariant: this.previousVariant || null,
            formElement: document.querySelector(
              `#product-form-${this.dataset.section}`
            ),
            sectionId: this.dataset.section,
          },
        })
      );

      // Save the previous version
      this.previousVariant = this.currentVariant;
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      this.currentVariant = this.getVariantData().find((variant) => {
        this.options.sort();
        variant.options.sort();

        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    const swiperWrappers = document.querySelectorAll(".product__media-wrapper");

    swiperWrappers.forEach((elem) => {
      if (!this.isHidden(elem)) {
        const newMedia = elem.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        const parent = newMedia.parentElement;

        if (elem.querySelector(".js-media-list")) {
          elem
            .querySelector(".js-media-list")
            .swiper.slideTo(
              elem
                .querySelector(".js-media-list")
                .swiper.slides.indexOf(newMedia)
            );
        } else {
          newMedia && parent.prepend(newMedia);

          if (window.innerWidth < 750) {
            newMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }

          window.setTimeout(() => {
            parent.scroll(0, 0);
          });
        }
      }
    });
  }

  updateURL() {
    if (!this.classList.contains("featured-product-radios")) {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
  }

  updateVariantInput() {
    // Check if we have a current variant
    if (!this.currentVariant) {
      console.error('[VariantSelects] Cannot update variant input: no current variant');
      return;
    }

    // Query all product forms for this section (floated now uses the same form as desktop/mobile)
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );

    // Check if any forms were found
    if (productForms.length === 0) {
      console.warn('[VariantSelects] No product forms found for section:', this.dataset.section);
      return;
    }

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      // Check if input exists before using it
      if (!input) {
        console.error('[VariantSelects] No hidden input[name="id"] found in form:', productForm.id);
        return;
      }

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  getVariantFocusState() {
    const activeElement = document.activeElement;
    if (!activeElement) return null;

    const variantRadios = activeElement.closest('variant-radios');
    if (!variantRadios) return null;

    let wrapper = null;
    if (variantRadios.id?.includes('floated')) {
      wrapper = 'floated';
    } else if (variantRadios.closest('.main-product-desktop-section-wrapper')) {
      wrapper = 'desktop';
    } else if (variantRadios.closest('.main-product-mobile-section-wrapper')) {
      wrapper = 'mobile';
    }

    if (!wrapper) return null;

    if (activeElement.id) {
      return { wrapper, type: 'id', value: activeElement.id };
    }

    if (activeElement.matches('label[for]')) {
      return { wrapper, type: 'for', value: activeElement.getAttribute('for') };
    }

    if (activeElement.name && typeof activeElement.value === 'string') {
      return {
        wrapper,
        type: 'name-value',
        name: activeElement.name,
        value: activeElement.value
      };
    }

    return null;
  }

  restoreVariantFocusState(focusState) {
    if (!focusState) return;

    const escapeSelector = (value) => {
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(value);
      }
      return value.replace(/["\\]/g, '\\$&');
    };

    const wrappers = {
      floated: document.querySelector('variant-radios[id*="floated"]'),
      desktop: document.querySelector('.main-product-desktop-section-wrapper variant-radios'),
      mobile: document.querySelector('.main-product-mobile-section-wrapper variant-radios')
    };

    const root = wrappers[focusState.wrapper];
    if (!root) return;

    let target = null;

    if (focusState.type === 'id' && focusState.value) {
      target = root.querySelector(`#${escapeSelector(focusState.value)}`);
    } else if (focusState.type === 'for' && focusState.value) {
      target = root.querySelector(`label[for="${escapeSelector(focusState.value)}"]`);
      if (target) {
        const inputByFor = root.querySelector(`#${escapeSelector(focusState.value)}`);
        if (inputByFor) target = inputByFor;
      }
    } else if (focusState.type === 'name-value' && focusState.name) {
      const escapedName = escapeSelector(focusState.name);
      const escapedValue = escapeSelector(focusState.value);
      target = root.querySelector(`[name="${escapedName}"][value="${escapedValue}"]`);
    }

    if (!target || typeof target.focus !== 'function') return;

    target.focus({ preventScroll: true });
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const focusState = this.getVariantFocusState();

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (!this.currentVariant || this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sectionId = this.dataset.section;
        const sourceSectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;
        const source = html.getElementById(`price-${sourceSectionId}`);

        this.syncElementsFromFetch(
          html,
          `price-${sourceSectionId}`,
          `price-${sectionId}`,
          { showVisible: true }
        );
        this.syncElementsFromFetch(
          html,
          `Inventory-${sourceSectionId}`,
          `Inventory-${sectionId}`,
          { hideWhenEmpty: true }
        );
        this.syncElementsFromFetch(
          html,
          `Sku-${sourceSectionId}`,
          `Sku-${sectionId}`,
          { copyVisibilityClass: true }
        );
        this.syncElementsFromFetch(
          html,
          `ColorName-${sourceSectionId}`,
          `ColorName-${sectionId}`
        );

        const floatedPrice = document.getElementById(`price-floated-${sectionId}`);
        if (floatedPrice && source) {
          floatedPrice.innerHTML = source.innerHTML;
          floatedPrice.classList.remove("visibility-hidden");
        }

        // Update variant pickers for all wrappers (desktop, mobile, floated)
        this.updateVariantPickersFromAPI(html, sectionId, focusState);

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        // product media
        if (this.dataset?.variantMediaDisplay !== 'show_all') {
          const sourceSectionId = this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section;
          const currentSectionId = this.dataset.section;

          const mediaSources = html.querySelectorAll(
            `[data-section="product-media-${sourceSectionId}"]`
          );
          const mediaDestinations = document.querySelectorAll(
            `[data-section="product-media-${currentSectionId}"]`
          );

          if (mediaDestinations[0] && mediaSources[0]) {
            mediaDestinations[0].innerHTML = mediaSources[0].innerHTML;

            if (mediaDestinations[1] && mediaSources[1]) {
              mediaDestinations[1].innerHTML = mediaSources[1].innerHTML;
            }

            const parentQuickView = this.closest('quick-view-modal');
            if (parentQuickView) {
              if (typeof parentQuickView.removeDOMElements === 'function') {
                parentQuickView.removeDOMElements(mediaDestination);
              }
              if (typeof parentQuickView.initSlider === 'function') {
                parentQuickView.initSlider();
              }
            } else {
              const section = document.getElementById(
                `shopify-section-${currentSectionId}`
              );

              if (section && typeof initProductPage === 'function') {
                initProductPage(section);
              }
            }
            if (document.querySelector('.js-media-list')) {
              if (currentSectionId.includes('quickadd')) {
                quickAddsliderInit(true);
              } else {
                subSliderInit(true);
                sliderInit(true);
              }
            }
          }
        }

      })
      .catch((error) => {
        console.error('[VariantRadios] Failed to fetch variant info:', error);
        // Keep existing UI state on error - don't break the page
        // The variant selection still works, just price/images won't update
      });
  }

  updateVariantPickersFromAPI(html, sectionId, focusState = null) {
    // Helper function to update a single variant picker
    const updateVariantPicker = (source, dest) => {
      if (!source || !dest) return;

      dest.innerHTML = source.innerHTML;

      if (dest.initMasterInputSync) {
        dest._masterInputSyncInitialized = false;
        dest.initMasterInputSync();
      }
    };

    // Define wrapper configurations for each context
    const wrapperConfigs = [
      {
        name: 'floated',
        getSource: () => html.querySelector(`variant-radios[id*="floated"]`),
        getDest: () => document.querySelector(`variant-radios[id*="floated"]`)
      },
      {
        name: 'desktop',
        getSource: () => html.querySelector('.main-product-desktop-section-wrapper')?.querySelector('variant-radios'),
        getDest: () => document.querySelector('.main-product-desktop-section-wrapper')?.querySelector('variant-radios')
      },
      {
        name: 'mobile',
        getSource: () => html.querySelector('.main-product-mobile-section-wrapper')?.querySelector('variant-radios'),
        getDest: () => document.querySelector('.main-product-mobile-section-wrapper')?.querySelector('variant-radios')
      }
    ];

    // Update all wrappers
    wrapperConfigs.forEach(config => {
      const source = config.getSource();
      const dest = config.getDest();
      updateVariantPicker(source, dest);
    });

    if (focusState) {
      requestAnimationFrame(() => this.restoreVariantFocusState(focusState));
    }
  }

  syncElementsFromFetch(sourceDocument, sourceId, destinationId, options = {}) {
    const source = sourceDocument.getElementById(sourceId);
    const destinations = document.querySelectorAll(`[id="${destinationId}"]`);

    if (!source || destinations.length === 0) return;

    destinations.forEach((destination) => {
      destination.innerHTML = source.innerHTML;

      if (options.copyVisibilityClass) {
        destination.classList.toggle(
          "visibility-hidden",
          source.classList.contains("visibility-hidden")
        );
      }

      if (options.hideWhenEmpty) {
        destination.classList.toggle(
          "visibility-hidden",
          source.innerText.trim() === ""
        );
      }

      if (options.showVisible) {
        destination.classList.remove("visibility-hidden");
      }
    });
  }

  hideAllSectionElements(elementId) {
    document.querySelectorAll(`[id="${elementId}"]`).forEach((element) => {
      element.classList.add("visibility-hidden");
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const sectionId = this.dataset.section;
    const productForms = document.querySelectorAll(
      `#product-form-${sectionId}, #product-form-installment-${sectionId}`
    );
    const addButtons = [];

    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (addButton) addButtons.push(addButton);
    });

    document
      .querySelectorAll(`button[name="add"][form="product-form-${sectionId}"]`)
      .forEach((addButton) => {
        if (!addButtons.includes(addButton)) addButtons.push(addButton);
      });

    if (addButtons.length === 0) return;

    const notifyButtons = document.querySelectorAll(
      `[id="notify-button-${sectionId}"]`
    );

    addButtons.forEach((addButton) => {
      const addButtonText = addButton.querySelector("span");

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text && addButtonText) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        if (addButtonText) {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    });

    notifyButtons.forEach((notifyButton) => {
      if (disable && text) {
        notifyButton.setAttribute("disabled", "disabled");
      } else if (!disable) {
        notifyButton.removeAttribute("disabled");
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const sectionId = this.dataset.section;

    this.toggleAddButton(true, window.variantStrings.unavailable);
    this.hideAllSectionElements(`price-${sectionId}`);
    this.hideAllSectionElements(`Inventory-${sectionId}`);
    this.hideAllSectionElements(`Sku-${sectionId}`);
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  // Supported wrapper context suffixes
  static WRAPPER_CONTEXTS = ['desktop', 'mobile', 'floated'];

  constructor() {
    super();
    this.initMasterInputSync();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
        (radio) => radio.checked
      )?.value;
    });
  }

  initMasterInputSync() {
    // Prevent duplicate initialization
    if (this._masterInputSyncInitialized) return;
    this._masterInputSyncInitialized = true;

    // Find all variant inputs (radio AND select) and combine them
    const radioInputs = Array.from(this.querySelectorAll('input[type="radio"]:not([data-master-input])'));
    const selectInputs = Array.from(this.querySelectorAll('select:not([data-master-input])'));
    const allVariantInputs = [...radioInputs, ...selectInputs];

    // Single unified handler for both radio and select inputs
    const handleVariantInputChange = (event) => {
      const target = event.target;
      // For radio inputs, skip if not checked
      if (target.type === 'radio' && !target.checked) return;

      // Skip if currently syncing
      if (this._isSyncing) {
        return;
      }

      // Extract base option name (remove wrapper context suffix)
      const fullName = target.name;
      const baseName = fullName.replace(
        new RegExp(`-(${VariantRadios.WRAPPER_CONTEXTS.join('|')})(-.*)?$`),
        ''
      );
      const value = target.value;
      // Update master input
      const masterInput = this.querySelector(`input[data-master-input][data-option-name="${baseName}"]`);
      if (masterInput) {
        const oldValue = masterInput.value;
        masterInput.value = value;
        // Dispatch change event if value actually changed
        // IMPORTANT: Set _isSyncing BEFORE dispatchEvent because it's synchronous!
        if (oldValue !== value && !this._isSyncing) {
          // Set syncing flag BEFORE dispatch (dispatch is synchronous!)
          this._isSyncing = true;

          masterInput.dispatchEvent(new Event('change', { bubbles: true }));

          // Sync master inputs to other wrappers (for form submission)
          // Variant inputs will be updated by Section Rendering API
          this.syncToOtherWrappers(baseName, value);
          this._isSyncing = false;
        }
      } else {
        console.warn('[VariantRadios] Master input not found for:', baseName);
      }
    };
    // Attach the unified handler to all variant inputs
    allVariantInputs.forEach(input => {
      input.addEventListener('change', handleVariantInputChange);
    });

    // Listen for changes on master inputs (single source of truth)
    const masterInputs = this.querySelectorAll('input[data-master-input]');
    masterInputs.forEach(masterInput => {
      masterInput.addEventListener('change', () => {
        // Call parent class method to update hidden input name="id" and render product info
        // This will only be called ONCE per variant change, not once per wrapper
        if (this.onVariantChange) {
          this.onVariantChange();
        }
      });
    });
  }

  syncToOtherWrappers(optionName, value) {
    const sectionId = this.dataset.section || this.dataset.originalSection;
    if (!sectionId) return;

    // Find all variant-radios instances with matching section ID
    const allVariantRadios = document.querySelectorAll(
      `variant-radios[data-section="${sectionId}"], variant-radios[data-original-section="${sectionId}"]`
    );

    allVariantRadios.forEach(variantRadio => {
      if (variantRadio === this) return; // Skip self

      // Only update master input (for form submission)
      // Variant inputs will be updated by Section Rendering API
      const masterInput = variantRadio.querySelector(
        `input[data-master-input][data-option-name="${optionName}"]`
      );

      if (masterInput && masterInput.value !== value) {
        variantRadio._isSyncing = true;
        masterInput.value = value;
        variantRadio._isSyncing = false;
      }
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class PasswordViewer {
  constructor() {
    const passwordField = document.querySelectorAll(".field--pass");

    passwordField.forEach((el) => {
      const input = el.querySelector("input");
      const btnWrapper = el.querySelector(".button-pass-visibility");
      const btnOpen =
        el.querySelector(".icon-eye-close") !== null
          ? el.querySelector(".icon-eye-close")
          : el.querySelector(".pass-hide");
      const btnClose =
        el.querySelector(".icon-eye") !== null
          ? el.querySelector(".icon-eye")
          : el.querySelector(".pass-show");

      input.addEventListener("input", () => {
        input.value !== ""
          ? (btnWrapper.style.display = "block")
          : (btnWrapper.style.display = "none");
      });

      btnOpen.addEventListener("click", () => {
        input.type = "text";
        btnOpen.style.display = "none";
        btnClose.style.display = "block";
      });

      btnClose.addEventListener("click", () => {
        input.type = "password";
        btnOpen.style.display = "block";
        btnClose.style.display = "none";
      });
    });
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          let recommendations = html.querySelector("product-recommendations");
          if (this.hasAttribute("data-brand-filter")) {
            // Without a response, build the section from the fallback list only
            if (!recommendations) {
              recommendations = document.createElement("div");
              recommendations.innerHTML = this.innerHTML;
            }
            this.filterByBrand(recommendations);
          }
          const recommendationsList = recommendations?.querySelector(
            ".product-recommendations__wrapper"
          );
          const hasRecommendations = recommendationsList?.children.length > 0;

          if (recommendations && hasRecommendations) {
            this.innerHTML = recommendations.innerHTML;
          } else {
            const section = this.closest(".shopify-section");
            if (section) {
              section.style.display = "none";
            } else {
              this.style.display = "none";
            }
            return;
          }

          /* Color swatches */
          const generateSrcset = (image, widths = []) => {
            const imageUrl = new URL(image["src"]);
            return widths
              .filter((width) => width <= image["width"])
              .map((width) => {
                imageUrl.searchParams.set("width", width.toString());
                return `${imageUrl.href} ${width}w`;
              })
              .join(", ");
          };

          const createImageElement = (image, classes, sizes, productTitle) => {
            const previewImage = image["preview_image"];
            const newImage = new Image(
              previewImage["width"],
              previewImage["height"]
            );
            newImage.className = classes;
            newImage.alt = image["alt"] || productTitle;
            newImage.sizes = sizes;
            newImage.src = previewImage["src"];
            newImage.srcset = generateSrcset(
              previewImage,
              [165, 360, 533, 720, 940, 1066]
            );
            newImage.loading = "lazy";
            return newImage;
          };

          const checkSwatches = () => {
            document
              .querySelectorAll(".js-color-swatches-wrapper")
              .forEach((wrapper) => {
                wrapper
                  .querySelectorAll(".js-color-swatches input")
                  .forEach((input) => {
                    input.addEventListener("click", (event) => {
                      const primaryImage =
                        wrapper.querySelector(".media--first");
                      const secondaryImage =
                        wrapper.querySelector(".media--second");
                      const handleProduct = wrapper.dataset.product;

                      if (event.currentTarget.checked && primaryImage) {
                        wrapper
                          .querySelector(".js-color-swatches-link")
                          .setAttribute(
                            "href",
                            event.currentTarget.dataset.variantLink
                          );
                        if (
                          wrapper.querySelector(
                            '.card__add-to-cart button[name="add"]'
                          )
                        ) {
                          wrapper
                            .querySelector(
                              '.card__add-to-cart button[name="add"]'
                            )
                            .setAttribute("aria-disabled", false);
                          if (
                            wrapper.querySelector(
                              '.card__add-to-cart button[name="add"] > span'
                            )
                          ) {
                            wrapper
                              .querySelector(
                                '.card__add-to-cart button[name="add"] > span'
                              )
                              .classList.remove("hidden");
                            wrapper
                              .querySelector(
                                '.card__add-to-cart button[name="add"] .sold-out-message'
                              )
                              .classList.add("hidden");
                          }
                          wrapper.querySelector(
                            '.card__add-to-cart input[name="id"]'
                          ).value = event.currentTarget.dataset.variantId;
                        }
                        const currentColor = event.currentTarget.value;
                        const productDisplayTitle = wrapper.dataset.productDisplayTitle || '';

                        jQuery.getJSON(
                          window.Shopify.routes.root +
                          `products/${handleProduct}.js`,
                          function (product) {
                            const variant = product.variants.filter(
                              (item) =>
                                item.featured_media != null &&
                                item.options.includes(currentColor)
                            )[0];

                            if (variant) {
                              const newPrimaryImage = createImageElement(
                                variant["featured_media"],
                                primaryImage.className,
                                primaryImage.sizes,
                                productDisplayTitle || product.title
                              );

                              if (newPrimaryImage.src !== primaryImage.src) {
                                let flag = false;
                                if (secondaryImage) {
                                  const secondaryImagePathname = new URL(
                                    secondaryImage.src
                                  ).pathname;
                                  const newPrimaryImagePathname = new URL(
                                    newPrimaryImage.src
                                  ).pathname;

                                  if (
                                    secondaryImagePathname ==
                                    newPrimaryImagePathname
                                  ) {
                                    primaryImage.remove();
                                    secondaryImage.classList.remove(
                                      "media--second"
                                    );
                                    secondaryImage.classList.add(
                                      "media--first"
                                    );
                                    flag = true;
                                  }
                                }
                                if (flag == false) {
                                  primaryImage.animate(
                                    { opacity: [1, 0] },
                                    {
                                      duration: 200,
                                      easing: "ease-in",
                                      fill: "forwards",
                                    }
                                  ).finished;
                                  setTimeout(function () {
                                    primaryImage.replaceWith(newPrimaryImage);
                                    newPrimaryImage.animate(
                                      { opacity: [0, 1] },
                                      { duration: 200, easing: "ease-in" }
                                    );
                                    if (secondaryImage) {
                                      secondaryImage.remove();
                                    }
                                  }, 200);
                                }
                              }
                            }
                          }
                        );
                      }
                    });
                  });
              });
          };

          checkSwatches();

          const calcTop = (section) => {
            const imageWrapper = section.querySelectorAll(".card__inner");
            let top = 0;

            if (imageWrapper) {
              top = imageWrapper[0]?.offsetHeight / 2;
            } else {
              top = 50;
            }

            return top;
          };

          const initSlider = () => {
            document
              .querySelectorAll(".js-recommendation-swiper")
              .forEach((elem, index) => {
                let mobileLayout = 1;
                if (elem.dataset.mobileLayout) {
                  mobileLayout = elem.dataset.mobileLayout;
                }
                let slider = new Swiper(elem, {
                  slidesPerView: mobileLayout,
                  spaceBetween: 8,
                  speed: 600,
                  navigation: {
                    nextEl: elem.querySelector(
                      ".product-recommendations__slider-nav .swiper-button-next"
                    ),
                    prevEl: elem.querySelector(
                      ".product-recommendations__slider-nav .swiper-button-prev"
                    ),
                  },
                  breakpoints: {
                    576: {
                      slidesPerView: 2,
                    },
                  },
                });
              });
          };

          const initSection = () => {
            const section = this;

            const sectionResizeObserver = new ResizeObserver((entries) => {
              const [entry] = entries;
              let top = calcTop(section);
              if (section.querySelector(".product-recommendations__slider-nav"))
                section.querySelector(
                  ".product-recommendations__slider-nav"
                ).style.top = top + "px";
            });

            sectionResizeObserver.observe(section);

            initSlider();
          };

          const initProductSlider = () => {
            const sliders = document.querySelectorAll(".product-card-js");

            sliders.forEach((slider, index) => {
              const productSlider = new Swiper(slider, {
                // See product-card-slider.js: 'auto' avoids the sub-pixel drift
                // that lets the next slide show through at the card edge.
                slidesPerView: 'auto',
                pagination: {
                  el: ".product-pagination .swiper-pagination",
                },
                navigation: {
                  nextEl: ".product-button-group .swiper-button-next",
                  prevEl: ".product-button-group .swiper-button-prev",
                },
              });
            });
          };

          initProductSlider();

          initSection();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 200px 0px",
    }).observe(this);
  }

  // Keeps only products of the current brand, then fills the remaining slots
  // from the fallback list rendered on the product page.
  filterByBrand(recommendations) {
    const limit = parseInt(this.dataset.limit, 10) || 4;
    const accessoriesSlots = Math.min(
      parseInt(this.dataset.accessoriesSlots, 10) || 0,
      limit
    );
    const fallbackList = this.querySelector(
      ".js-recommendations-fallback"
    )?.content.querySelector(".product-recommendations__wrapper");

    let list = recommendations.querySelector(
      ".product-recommendations__wrapper"
    );
    if (!list && fallbackList) {
      list = fallbackList.cloneNode(false);
      recommendations
        .querySelector(".product-recommendations__content")
        ?.append(list);
    }
    if (!list) return;

    const related = [...list.children].filter(
      (item) =>
        item.dataset.vendor === this.dataset.vendor &&
        item.dataset.productId !== this.dataset.productId
    );
    const fallback = fallbackList ? [...fallbackList.children] : [];
    const others = [
      ...related,
      ...fallback.filter((item) => item.dataset.source !== "accessories"),
    ];
    const accessories = fallback.filter(
      (item) => item.dataset.source === "accessories"
    );

    const picked = [];
    const pickedIds = new Set();
    const pick = (pool, max) => {
      for (const item of pool) {
        if (picked.length >= max) break;
        if (pickedIds.has(item.dataset.productId)) continue;
        pickedIds.add(item.dataset.productId);
        picked.push(item);
      }
    };

    pick(others, limit - accessoriesSlots);
    pick(accessories, limit);
    pick(others, limit);

    list.replaceChildren(...picked);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

(function () {
  const initHeaderOverlay = () => {
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    if (sections.length > 0) {
      const sectionFirstChild = sections[0].querySelector(
        ".section--has-overlay"
      );
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );
      const header = document.querySelector(".shopify-section-header");

      if (sectionFirstChild) {
        const classes = getHeaderColorClasses(header);
        if (sectionFirstChild.classList.contains("section--has-overlay")) {
          if (headerGroupSections[headerGroupSections.length - 1] === header) {
            sections[0].classList.remove("not-margin");
            header.classList.add(classes.solid, classes.transparent);
          } else {
            sections[0].classList.add("not-margin");
            header.classList.remove(classes.solid, classes.transparent, "color-background-1", "color-background-2");
          }
        } else {
          sections[0].classList.remove("not-margin");
          header.classList.remove(classes.solid, classes.transparent, "color-background-1", "color-background-2");
        }
      }
    }
  };

  initHeaderOverlay();

  document.addEventListener("shopify:section:load", function () {
    initHeaderOverlay();
  });

  document.addEventListener("shopify:section:unload", function () {
    initHeaderOverlay();
  });

  document.addEventListener("shopify:section:reorder", function () {
    initHeaderOverlay();
  });
})();

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  cents = parseInt(cents, 10);
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || theme.moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return "0";
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = precision > 0 ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  const formatType = match ? match[1] : "amount";

  switch (formatType) {
    case "amount":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", ".");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    default:
      value = formatWithDelimiters(cents, 2, ",", ".");
  }

  return formatString.replace(placeholderRegex, value);
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector(".disclosure__button-modal"),
      panel:
        this.querySelector("[data-localization-panel]") ||
        this.querySelector("ul"),
      buttonSave: this.querySelector(".button-save"),
      buttonSpan: this.querySelector(".disclosure__button-modal span"),
    };

    // Example usage:
    const targetElement = this.elements.button;
    const excludeElement = this.elements.panel;

    this.elements.button?.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );

    this.elements.buttonSave?.addEventListener(
      "click",
      this.onClickSave.bind(this)
    );

    this.handleClickOutside(targetElement, excludeElement);
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  handleClickOutside(target, exclude) {
    document.addEventListener("click", (event) => {
      if (
        !target.contains(event.target) &&
        (!exclude || !exclude.contains(event.target))
      ) {
        this.hidePanel();
      }
    });
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    if (
      document.querySelectorAll(".region_language_dropdown_type").length > 0
    ) {
      this.querySelector("form")?.submit();
    } else {
      let itemValue = event.currentTarget.dataset.valuesave;
      this.elements.buttonSpan.textContent = event.currentTarget.textContent;
      this.elements.button.setAttribute("data-value", itemValue);
      this.hidePanel();
    }
  }

  onClickSave() {
    this.querySelector("form")?.submit();
  }

  // SUROWA perf: pozycje listy (np. 141 krajów) przychodzą w <template data-perf-lazy-list>
  // i trafiają do DOM dopiero przy pierwszym otwarciu, z tymi samymi obsługami kliknięć.
  perfHydrate() {
    const template = this.querySelector("template[data-perf-lazy-list]");
    if (!template) return false;
    template.content
      .querySelectorAll("a")
      .forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
      );
    template.replaceWith(template.content);
    return true;
  }

  openSelector() {
    this.perfHydrate();
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
    document.body.classList.add("region-open");
  }

  closeSelector(event) {
    if (!this.contains(event.relatedTarget)) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);

class LocalizationFormSearch extends LocalizationForm {
  constructor() {
    super();
    this.searchInput = this.querySelector("[data-localization-search-input]");
    this.emptyState = this.querySelector("[data-localization-empty]");
    this.items = Array.from(this.querySelectorAll(".disclosure__item"));

    this.searchInput?.addEventListener("input", (event) => {
      this.filterItems(event.target.value);
    });
  }

  perfHydrate() {
    const hydrated = super.perfHydrate();
    if (hydrated) this.items = Array.from(this.querySelectorAll(".disclosure__item"));
    return hydrated;
  }

  hidePanel() {
    if (this.searchInput) {
      this.searchInput.value = "";
    }
    this.filterItems("");
    super.hidePanel();
  }

  openSelector() {
    super.openSelector();
    this.filterItems("");
    this.searchInput?.focus();
  }

  filterItems(value) {
    const searchValue = this.normalizeValue(value);
    let hasVisibleItems = false;

    this.items.forEach((item) => {
      const link = item.querySelector(".disclosure__link");
      const itemSearchValue = this.normalizeValue(
        link?.dataset.searchNormalized || ""
      );
      const isVisible =
        searchValue.length === 0 || itemSearchValue.includes(searchValue);
      item.toggleAttribute("hidden", !isVisible);
      if (isVisible) hasVisibleItems = true;
    });

    if (this.emptyState) {
      this.emptyState.toggleAttribute("hidden", hasVisibleItems);
    }
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    if (
      document.querySelectorAll(".region_language_dropdown_type").length > 0
    ) {
      this.querySelector("form")?.submit();
    } else {
      let itemValue = event.currentTarget.dataset.valuesave;
      this.elements.buttonSpan.textContent = event.currentTarget.textContent;
      this.elements.button.setAttribute("data-value", itemValue);
      this.hidePanel();
      this.elements.buttonSave?.focus();
    }
  }

  normalizeValue(value) {
    return value
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }
}

customElements.define("localization-form-search", LocalizationFormSearch);

(function () {
  const imagesnumber = () => {
    $(document).scroll(scrolled);
    $(document).ready(scrolled);

    const scroll_line = 32;

    function scrolled() {
      const images = $(".img-responsive");
      for (var i = 2; i < images.length; i++) {
        let pos = images.eq(i).offset().top - $(document).scrollTop();
        if (pos > scroll_line) {
          break;
        }
      }
      let current_image = i;

      $("#image_number .first_number").html(
        current_image > 10 ? current_image : "0" + current_image
      );
    }
  };
  document.addEventListener("DOMContentLoaded", function () {
    imagesnumber();
    document.addEventListener("shopify:section:load", function () {
      imagesnumber();
    });
  });
})();

(function () {
  const selectDropDown = () => {
    $(".product-form__controls--dropdown").each(function () {
      const elListItem = $(this).find(".dropdown-select ul li");
      const elItem = $(this).find(".dropdown-select ul");
      const selectedText = $(this).find(".dropdown-select .select-label");

      selectedText.on("click", function (e) {
        elItem.toggleClass("active");
        if (elItem.hasClass("active")) {
          e.stopPropagation();
          $(document).click(function () {
            elItem.removeClass("active");
          });
        }
      });

      elListItem.on("click", function () {
        if ($(this).find("input").hasClass("disabled") == false) {
          selectedText
            .find("span")
            .text($(this).text())
            .attr("title", $(this).text());
        }

        elItem.removeClass("active");
        document.activeElement.blur();
      });
    });
  };
  document.addEventListener("DOMContentLoaded", function () {
    selectDropDown();
    document.addEventListener("shopify:section:load", function () {
      selectDropDown();
    });
  });
})();

function isSafari() {
  const userAgent = navigator.userAgent;
  return /Safari/.test(userAgent) && !/Chrome/.test(userAgent) && !/Edge/.test(userAgent);
}

// CART REFRESH EVENT
// -----------------------------------------------------------------------------

document.documentElement.addEventListener("cart:refresh", () => {
  const sectionsToUpdate = [
    { id: "cart-count-bubble", selector: "#cart-icon-bubble" },
    { id: "cart-drawer", selector: "#CartDrawer" },
    { id: "main-cart-items", selector: ".cart-items-wrapper" },
    { id: "main-cart-footer", selector: ".cart__footer" },
    { id: "main-cart-shipping", selector: ".cart-shipping" },
  ];

  sectionsToUpdate.forEach((section) => {
    fetch(`${routes.cart_url}?section_id=${section.id}`)
      .then((response) => response.text())
      .then((html) => {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const sourceSection = parsedHTML.querySelector(section.selector);
        const destinationSection = document.querySelector(section.selector);
        if (sourceSection && destinationSection) {
          destinationSection.innerHTML = sourceSection.innerHTML;
        }
      })
      .catch((e) => console.error(`Error updating ${section.id}:`, e));
  });
});

// CART REFRESH EVENT END
// -----------------------------------------------------------------------------

// PROMOTION TRACKING
// -----------------------------------------------------------------------------

(function () {
  const viewedPromotions = new Set();

  function getPromotionData(el) {
    return {
      promotion_id: el.dataset.promotionId,
      promotion_name: el.dataset.promotionName,
      creative_name: el.dataset.creativeName,
      creative_slot: el.dataset.creativeSlot,
    };
  }

  function initPromotionTracking() {
    const promoElements = document.querySelectorAll('[data-promotion]');
    if (!promoElements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const key = `${el.dataset.creativeSlot}:${el.dataset.promotionId}`;
        if (viewedPromotions.has(key)) return;
        viewedPromotions.add(key);
        Shopify.analytics.publish('my_store:view_promotion', getPromotionData(el));
      });
    }, { threshold: 0.5 });

    promoElements.forEach((el) => {
      observer.observe(el);

      el.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          Shopify.analytics.publish('my_store:select_promotion', getPromotionData(el));
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initPromotionTracking);
  document.addEventListener('shopify:section:load', initPromotionTracking);
})();

// PROMOTION TRACKING END
// -----------------------------------------------------------------------------

